import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(() => {
  let token
  if (import.meta.server) {
    token = useCookie('token').value
  } else {
    const store = useCurrentUserStore()
    token = store.data?.token
  }
  if (!token) {
    return '/'
  }
})
